var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaced(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1727 25.9584H3V29C3 30.6569 4.34315 32 6 32H23.1727C24.8296 32 26.1727 30.6569 26.1727 29V25.9584Z",
    fill: "#12D9E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0344 13.0617L19.7354 23.1983H17.1606L17.8043 20.5896L28.747 9.82874L30.9999 12.1113L30.0344 13.0617ZM30.0344 13.0617L30.9999 14.0679L28.1033 17.0026",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.229 23.525H8.14844",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.229 18.3004H8.14844",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4474 13.084H8.14844",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1727 9.17391V5C26.1727 3.34315 24.8296 2 23.1727 2H6C4.34315 2 3 3.34315 3 5V29C3 30.6569 4.34315 32 6 32H23.1727C24.8296 32 26.1727 30.6569 26.1727 29V22.8696",
    stroke: "#383434",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaced);
export default __webpack_public_path__ + "static/media/Placed.ad568ec76fa6a2d0629f2d94c5de348e.svg";
export { ForwardRef as ReactComponent };